<template>
  <div class="container-fluid">
    <div class="row pt-4">
      <div class="col-8">
        <p class="page-title">
          <i class="fas fa-history"></i> Actions
        </p>
      </div>
      <div class="col-4">
        <div class="input-group bmo-form">
            <select class="form-control form-select mr-2" v-model="filter" @change="changeFilter">
              <option value="all">All actions</option>
              <option value="user">Filter by user</option>
              <option value="product">Filter by SKU</option>
            </select> 
            <select v-if="filter === 'user'" class="form-control" v-model="userId" @change="changeFilterId">
              <option value>Select a user</option>
              <option v-for="(value,key) in users" :key="key" :value="key">{{ value }}</option>
            </select>
            <input v-if="filter === 'product'" class="form-control" v-model="skuId" type="text" placeholder="Enter a SKU" @change="changeFilterId" /> 
        </div>  
      </div>
    </div>
    <div class="row">
      <div class="col">
        <GridTable id="actions_table" :data="gridData" :columns="gridColumns" :sortable="true" @diff="showModalDiff($event)" @sortData="changePage($event)"/>
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
      </div>
    </div>
    <b-modal ref="modal" :title="modal.title" size="xl" ok-only>
      <div class="panel bg-white rounded shadow-sm">
        <div class="overflow-x-auto">
          <table id="diff_table" class="table w-full" v-if="Object.keys(modal.content).length > 0">
            <thead class="border-b border-grey-light">
              <tr class="bg-grey-lighter">
                <th class="id-col w-1 text-left text-xs text-grey-dark uppercase px-2 py-3">Field</th>
                <th class="id-col w-1 text-left text-xs text-grey-dark uppercase px-2 py-3">Previous value</th>
                <th class="id-col w-1 text-left text-xs text-grey-dark uppercase px-2 py-3">Current value</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowName, rowIndex) in modal.content" :key="rowIndex" class="border-b border-grey-light hover:bg-grey-lightest">
                <td class="text-left text-sm" :style="{ height: '2rem' }">{{ row[0] }}</td>
                <td class="text-left text-sm" :style="{ height: '2rem' }">{{ row[1].old }}</td>
                <td class="text-left text-sm" :style="{ height: '2rem' }">{{ row[1].current }}</td>                                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BPagination } from 'bootstrap-vue';
//import { GridTable } from '@dmunoz/gridtable';
import GridTable from '@/components/MarketplacesGrid/MarketplacesGrid.vue';
import ActionsApiRequest from '@/components/ApiRequester/Action';

const ApiRequest = new ActionsApiRequest();

export default {
  name: 'Actions',
  components: {
    BModal,
    BPagination,   
    GridTable,
  },
  data() {
    return {
      modal: {
        title: '',
        content: '',
      },
      filter: 'all',
      filterId: '',
      userId: '',       
      skuId: '',
      users: {},
      totalRows: 0,
      page: 1,
      sortable: true,
      gridData: [],
      gridColumns: [
        {
          column: 'Event time (PST)',
          index: 'created_at',
          type: 'raw',
          sortable: 'createdAt',
          defaultSort: -1,
        },
        {
          column: 'User',
          index: 'user_id',
          type: 'raw',
          sortable: 'userId',
          defaultSort: 1,
        },
        {
          column: 'Page',
          index: 'route',
          type: 'raw',
          sortable: 'route',
          defaultSort: 1,         
        },
        {
          column: 'Event',
          index: 'event',
          type: 'event',
          eventName: 'diff'
        },
        {
          column: 'Product SKU',
          index: 'objectSku',
          type: 'raw',
        }
      ],
    };
  },
  computed: {
    perPage: () => 25
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    ApiRequest.all({
      filter: this.filter,
      filterId: this.filterId,
      userId: this.userId,       
      skuId: this.skuId,
      users: this.users,
      page: this.page,
      per_page: this.perPage,
    }).then((response) => {
      const { total, data } = response.data;
      this.gridData = data;
      this.totalRows = total;

      document.getElementById('loader').classList.remove('active');
    }).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
    ApiRequest.finishCall();
  },
  methods: {

    showModalDiff(entry) {
      this.modal = Object.assign({}, {
          title: 'Changes',
          content: Object.entries(entry['objectOriginal']),
      });
      this.$refs.modal.show();
    },

    changeFilter() {
      let payload = {};
      if (this.filter !== '') {
        payload = Object.assign(payload, {
          filter: this.filter
        });
      }

      if (this.filter === 'product' && this.skuId !== ''){
        this.changeFilterId();
      }

      if (this.filter === 'user' && this.userId !== ''){
        this.changeFilterId();
      }  

      document.getElementById('loader').classList.add('active');
      ApiRequest.all(payload).then((response) => {
        if(this.filter === 'all'){
          const { total, data } = response.data;
          this.gridData = data;
          this.totalRows = total;
        } 
        if(this.filter === 'user'){
          this.users = response.data;          
        }
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },

    changeFilterId() {
      this.gridData = [];
      let payload = {};

      if (this.filter !== '') {
        payload = Object.assign(payload, {
          filter: this.filter,
          filterId: (this.skuId === '' ? this.userId: this.skuId),
        });
      }

      document.getElementById('loader').classList.add('active');
      ApiRequest.all(payload).then((response) => {
        const { data, total } = response.data
        this.gridData = Array.isArray(data) ? data : Object.values(data);
        this.totalRows = total;
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },

    changePage(obj) {

      this.gridData = [];

      let payload = { page: obj };

      if (this.filter !== '') {
        payload = Object.assign(payload, {
          filter: this.filter,
        });
      }

      if (this.filterId !== '') {
        payload = Object.assign(payload, {
          filterId: this.filterId,
        });
      }

      if (obj['key'] !== '') {
        payload = Object.assign(payload, {
          sortKey: obj['key'],
        });
      }

      if (obj['direction'] !== '') {
        payload = Object.assign(payload, {
          sortOrders: obj['direction'],
        });
      }

      document.getElementById('loader').classList.add('active');
      ApiRequest.all(payload).then((response) => {
        const { data, total } = response.data
        this.gridData = Array.isArray(data) ? data : Object.values(data);
        this.totalRows = total;
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },
  },
};
</script>
